import {FC, Fragment, PropsWithChildren} from "react";
import {SSOAdditionalFieldsModal} from "components";

export const HocSsoModal: FC<PropsWithChildren<unknown>> = ({children}) => {
	return (
		<Fragment>
			{children}
			<SSOAdditionalFieldsModal />
		</Fragment>
	);
};
